export const templateConstants = {
  TEMPLATE_LOAD: '[Template] Load',
  TEMPLATE_LOAD_SUCCESS: '[Template] Load success',
  TEMPLATE_LOAD_FAILURE: '[Template] Load failure',
  TEMPLATE_RESET: '[Template] Reset',
  TEMPLATE_SAVE: '[Template] Save',
  TEMPLATE_SAVE_SUCCESS: '[Template] Save success',
  TEMPLATE_SAVE_FAILURE: '[Template] Save failure',
  TEMPLATE_DELETE: '[Template] Delete',
  TEMPLATE_DELETE_SUCCESS: '[Template] Delete success',
  TEMPLATE_DELETE_FAILURE: '[Template] Delete failure'
}
